module.exports = __webpack_public_path__ + "static/media/site_name_logo.93611e39.png";